import { Component, OnDestroy, OnInit } from '@angular/core';
import { FuseConfig, FuseConfigService, Scheme } from '@fuse/services/config';

import { Subject, takeUntil } from 'rxjs';
import {NgClass} from "@angular/common";
import {MatIcon} from "@angular/material/icon";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'scheme-select',
    templateUrl: './scheme.selector.component.html',
    standalone: true,
    styleUrls: ['./scheme.selector.component.css'],
    imports: [
        NgClass,
        MatIcon,
        FormsModule
    ]
})
export class SchemeSelectorComponent implements OnInit, OnDestroy
{
    config: FuseConfig;
    scheme: 'dark' | 'light' = 'light';
    isDarkMode:boolean = false;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to config changes
        this._fuseConfigService.config$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config: FuseConfig) =>
            {
                // Store the config
                this.config = config;
            });

        const scheme=localStorage.getItem('UI_COLOR_SCHEME') ?? '';
        if(scheme == "dark" || scheme == "light"){
            this.scheme = scheme;
            this.isDarkMode = scheme == "dark";
            this.setScheme(this.scheme);
        }
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Set the scheme on the config
     *
     * @param scheme
     */
    setScheme(scheme: Scheme): void
    {
        this._fuseConfigService.config = {scheme};
        localStorage.setItem('UI_COLOR_SCHEME', scheme);
    }

    toggleScheme() {
        this.scheme=this.scheme == 'light'?'dark':'light';
        this.setScheme(this.scheme);
    }
}
